import { Loader } from "@/components/Loader/Loader";
import { Navbar } from "@/components/Navbar/Navbar";
import { CommerceContent } from "@/containers/Commerce/CommerceContent";
import { IndexPageRef } from "@/types";
import styled from "styled-components";
import { Footer } from "@/components/Footer/Footer";
import { useRouter } from "next/router";
import { CommerceDataEsp } from "@/data/CommerceData/esp";
import { CommerceDataCa } from "@/data/CommerceData/ca";
import { CommerceDataEn } from "@/data/CommerceData/en";
import { CommerceDataFr } from "@/data/CommerceData/fr";
import { GetServerSideProps } from "next";
import { getCommerceData, getHomeData } from "@/utils/backFunctions";

const CommerceWrapper = styled.main`
    background: ${(props) => props.theme.color.white};
    width: 100%;
    min-height: 100vh;
`;

export default function Commerce({ homeData, commerceData, ref }: { homeData: any; commerceData: any; ref: IndexPageRef }) {
    const { locale } = useRouter();

    return (
        <CommerceWrapper>
            <Navbar data={homeData} />
            {!homeData || !commerceData ? (
                <Loader />
            ) : (
                <>
                    <CommerceContent
                        data={commerceData}
                        formData={
                            locale === "es" ? CommerceDataEsp : locale === "en" ? CommerceDataEn : locale === "fr" ? CommerceDataFr : CommerceDataCa
                        }
                    />
                    <Footer data={homeData} />
                </>
            )}
        </CommerceWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
    const homeData = await getHomeData(locale as string);
    const commerceData = await getCommerceData(locale as string);
    console.log("commerceData", commerceData.data.attributes);
    return {
        props: {
            homeData: homeData?.data?.attributes || null,
            commerceData: commerceData?.data?.attributes || null,
        },
    };
};
